import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';

import { DocumentPurchaseFormType } from '../components/form-type';

export default function useRecalculate() {
  const { control, setValue } = useFormContext<DocumentPurchaseFormType>();
  const [documentPurchases, otherCost, discount] = useWatch({
    control,
    name: ['documentPurchases', 'otherCost', 'discount'],
  });

  const data = React.useMemo(() => {
    const subtotal = documentPurchases?.reduce((prev, hp) => {
      const subtotalGuest = hp?.documentPurchaseGuests
        ?.map((guest) => guest.details)
        .flat()
        .reduce((prev, detail) => prev + (detail.price || 0), 0);

      const subtotalAddons = hp?.documentPurchaseAddOns?.reduce(
        (prev, dpao) => {
          return prev + (dpao.price || 0);
        },
        0,
      );

      return prev + subtotalGuest + subtotalAddons;
    }, 0);

    const total = subtotal + (otherCost || 0) - (discount || 0);

    setValue('total', total);

    return {
      subtotal,
      otherCost,
      discount,
      total,
    };
  }, [discount, documentPurchases, otherCost, setValue]);

  return data;
}
